import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, FlexCol, FlexContainer, FlexRow, Label } from 'sarsaparilla';
import TextInput from '../../../../ui-lottery/src/components/inputs/TextInput';
import CheckboxInput from '../../../../ui-lottery/src/components/inputs/CheckboxInput';
import Alert from '../../../../ui-lottery/src/components/Alert';
import { AccountProps } from '../../props/account';
import { ApiKeyProps } from '../../props/apiKey';
import { OrgOptionProps } from '../../props/organization';

import * as styles from '../../containers/UserAdminPage/UserAdminPage.scss';

const propTypes = {
  disabled: PropTypes.bool,
  account: PropTypes.shape({
    account: AccountProps,
    apiKey: ApiKeyProps
  }),
  orgOptions: PropTypes.arrayOf(OrgOptionProps),
  onEnable: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
// column
const defaultProps = {
  disabled: true
};

export default class UserDisplay extends PureComponent {
  constructor(props) {
    super(props);

    this.enableDeveloperAccess = this.enableDeveloperAccess.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleOrgIdChange = this.handleOrgIdChange.bind(this);
  }

  enableDeveloperAccess() {
    this.props.onEnable()
      // .then((apiKey) => this.props.updateCurrentUser({ apiKey }))
      .catch((error) => {
        this.handleProfileUpdateError(error);
      });
  }

  handleCheckboxChange(event) {
    const { checked } = event.target;
    const { key } = event.target.dataset;

    this.props.onChange({ [key]: checked });
  }

  handleOrgIdChange(event) {
    const { value: orgId } = event.target;

    this.props.onChange({ orgId });
  }

  render() {
    const { disabled, account: { account, apiKey }, orgOptions } = this.props;
    const apiDetails = Object.assign({}, { locked: false, writeAccess: false, adminAccess: false }, apiKey);
    const hasResult = !!account.accountId;
    const isDeveloper = apiKey.externalId && apiKey.apiKey !== '';

    return (
      <div>
        <FlexContainer>
          {hasResult && !isDeveloper &&
          <Alert alert={{
            id: '1',
            level: 'info',
            title: 'Developer Access not enabled',
            message: 'User has not enabled developer access for this account'
          }} />
          }
          <FlexRow>
            <FlexCol>
              {!hasResult && (
                <div>
                  <p>No results</p>
                </div>
              )}
              {hasResult && isDeveloper && (
                <div>
                  <FlexRow>
                    <FlexCol>
                      <TextInput
                        id="user-first-name"
                        label="First Name"
                        readOnly
                        value={account.firstName} />
                    </FlexCol>
                    <FlexCol>
                      <TextInput
                        id="user-last-name"
                        label="Last Name"
                        readOnly
                        value={account.lastName} />
                    </FlexCol>
                  </FlexRow>
                  <FlexRow>
                    <FlexCol>
                      <TextInput
                        id="user-email"
                        label="Email"
                        readOnly
                        value={account.email} />
                    </FlexCol>
                    <FlexCol>
                      <TextInput
                        id="user-api-key"
                        label="API key"
                        readOnly
                        value={apiDetails.apiKey} />
                    </FlexCol>
                  </FlexRow>
                  <Divider />
                  <CheckboxInput
                    id="user-locked"
                    className={styles.danger}
                    label="Disable API Access"
                    name="address-save-to-profile"
                    value
                    data-key="locked"
                    checked={apiDetails.locked}
                    disabled={disabled}
                    onChange={this.handleCheckboxChange} />
                  <CheckboxInput
                    id="user-data-steward-access"
                    label="Data Steward Access"
                    value
                    data-key="writeAccess"
                    checked={apiDetails.writeAccess}
                    disabled={disabled}
                    onChange={this.handleCheckboxChange} />
                  <div className="rec-form-item-wrap">
                    <Label htmlFor="user-search-org">Organization</Label>
                    <select
                      id="user-search-org"
                      value={apiDetails.orgId}
                      disabled={disabled || !apiDetails.writeAccess}
                      onChange={this.handleOrgIdChange}>
                      <option value="">All Organizations</option>
                      {orgOptions.map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
                    </select>
                  </div>
                  <CheckboxInput
                    id="user-admin-access"
                    label="Admin Access"
                    value
                    data-key="adminAccess"
                    checked={apiDetails.adminAccess}
                    disabled={disabled}
                    onChange={this.handleCheckboxChange} />
                </div>
              )}
              {hasResult && !isDeveloper && (
                <div>
                  <Button appearance="secondary" onClick={this.enableDeveloperAccess}>Enable Developer Access For This User</Button>
                </div>
              )}
            </FlexCol>
          </FlexRow>
        </FlexContainer>
      </div>
    );
  }
}

UserDisplay.propTypes = propTypes;
UserDisplay.defaultProps = defaultProps;
